const STORAGE_KEY = "cc-extra-symbols";

export const ADDABLE_MARKETS = ["forex", "us", "indonesia", "iran", "australia", "japan", "ksa"];

const HINTS = {
  forex: "EURUSD",
  us: "AAPL",
  indonesia: "BBCA",
  iran: "فملی",
  australia: "BHP",
  japan: "7203",
  ksa: "2222",
};

export function symbolHint(market) {
  return HINTS[market] || "Symbol";
}

export function loadExtraSymbols(market) {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    const list = saved?.[market];
    return Array.isArray(list) ? list.map((item) => String(item)) : [];
  } catch (error) {
    return [];
  }
}

function writeExtraSymbols(market, list) {
  let saved = {};
  try {
    saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {};
  } catch (error) {
    saved = {};
  }
  saved[market] = list;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
}

export function normalizeAddedSymbol(market, raw) {
  const text = String(raw || "").trim();
  if (!text) return "";
  if (market === "iran") return text.replace(/\s+/g, " ");
  if (market === "forex") {
    const pair = text.toUpperCase().replace(/[^A-Z]/g, "");
    if (pair.length < 6) return "";
    return `${pair.slice(0, 6)}=X`;
  }
  const upper = text.toUpperCase().replace(/\s+/g, "");
  if (!upper) return "";
  if (market === "indonesia") {
    const stem = upper.replace(/\.JK$/, "");
    return stem ? `${stem}.JK` : "";
  }
  if (market === "australia") {
    const stem = upper.replace(/\.AX$/, "");
    return stem ? `${stem}.AX` : "";
  }
  if (market === "japan") {
    const stem = upper.replace(/\.T$/, "").replace(/\D/g, "");
    return stem.length === 4 ? `${stem}.T` : "";
  }
  if (market === "ksa") {
    const stem = upper.replace(/\.SR$/, "").replace(/\D/g, "");
    return stem.length >= 3 && stem.length <= 5 ? `${stem}.SR` : "";
  }
  return upper;
}

export function saveExtraSymbol(market, raw, existing = []) {
  const symbol = normalizeAddedSymbol(market, raw);
  if (!symbol) return "";
  const current = loadExtraSymbols(market);
  const known = new Set([...existing, ...current]);
  if (known.has(symbol)) return symbol;
  writeExtraSymbols(market, [...current, symbol]);
  return symbol;
}

export function removeExtraSymbol(market, symbol) {
  const next = loadExtraSymbols(market).filter((item) => item !== symbol);
  writeExtraSymbols(market, next);
}
